/**
 * @returns {boolean} - булевое значение, если устройство, которое открыло страницу является тачем
 */

function isTouch() {
  return 'ontouchstart' in document
}

export default isTouch
